import Api from "@/services/api.service";

export default {
  findDoctor(filter) {
    return Api().get("community/find-doctor/userList", { params: filter });
  },
  getDoctor(id) {
    return Api().get("community/find-doctor/userList/" + id);
  }
};
